import { useState } from 'react';
import { useReveal } from '@/hooks/useReveal';
import { useRtlDirection } from '@/hooks/useRtlDirection';
import Header from '@/components/feature/Header';
import Footer from '@/components/feature/Footer';
import WhatsAppButton from '@/components/feature/WhatsAppButton';
import MobileCTA from '@/components/feature/MobileCTA';
import DealerHero from './components/DealerHero';
import MembershipModelsSection from './components/MembershipModelsSection';
import PartnerModelsSection from './components/PartnerModelsSection';
import DealerRolesSection from './components/DealerRolesSection';
import DealerApplicationForm from './components/DealerApplicationForm';
import type { ApplicationType } from '@/types/domain';

export default function Dealership() {
  useRtlDirection();
  useReveal();
  const [applicationType, setApplicationType] = useState<ApplicationType | ''>('');

  const handleApply = (type: ApplicationType | '') => {
    setApplicationType(type);
    document.getElementById('basvuru')?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  return (
    <>
      <Header />
      <main>
        <DealerHero onApply={() => handleApply('')} />
        <MembershipModelsSection onApply={handleApply} />
        <PartnerModelsSection onApply={handleApply} />
        <DealerRolesSection />
        <DealerApplicationForm
          applicationType={applicationType}
          onChangeApplicationType={setApplicationType}
        />
      </main>
      <Footer />
      <WhatsAppButton />
      <MobileCTA href="#basvuru" labelKey="dealer.heroCta" />
    </>
  );
}